import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

export default function LegalNotice() {
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-grow bg-white">
        <div className="max-w-4xl mx-auto px-6 py-16 md:py-24">
          <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-8">
            Aviso Legal
          </h1>
          
          <div className="prose prose-lg max-w-none text-gray-700 space-y-8">
            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">1. Datos identificativos</h2>
              <p>
                En cumplimiento con el deber de información dispuesto en la Ley 34/2002 de Servicios de la Sociedad de la Información y el Comercio Electrónico (LSSI-CE), se facilitan los siguientes datos:
              </p>
              <ul className="list-none space-y-2 mt-4">
                <li><strong>Titular:</strong> David Rio Web</li>
                <li><strong>Actividad:</strong> Diseño y desarrollo de páginas web</li>
                <li><strong>Sitio web:</strong> davidrioweb.com</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">2. Objeto</h2>
              <p>
                El presente aviso legal regula el uso y utilización del sitio web davidrioweb.com, del que es titular David Rio Web. La navegación por el sitio web atribuye la condición de usuario del mismo e implica la aceptación plena y sin reservas de todas y cada una de las disposiciones incluidas en este Aviso Legal.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">3. Condiciones de uso</h2>
              <p>
                El acceso y uso de este sitio web está sujeto a las siguientes condiciones:
              </p>
              <ul className="list-disc pl-6 space-y-2">
                <li>El uso del sitio web es gratuito, salvo en lo relativo al coste de la conexión a través de la red de telecomunicaciones suministrada por el proveedor de acceso contratado por los usuarios</li>
                <li>El usuario se compromete a hacer un uso adecuado de los contenidos y servicios que se ofrecen a través del sitio web</li>
                <li>Queda prohibido el uso del sitio web con fines ilícitos o que perjudiquen los intereses de terceros</li>
                <li>El usuario se compromete a no transmitir, difundir o poner a disposición de terceros cualquier tipo de material que sea contrario a la ley</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">4. Propiedad intelectual e industrial</h2>
              <p>
                Todos los contenidos del sitio web, incluyendo pero no limitándose a textos, fotografías, gráficos, imágenes, iconos, tecnología, software, así como su diseño gráfico y códigos fuente, constituyen una obra cuya propiedad pertenece a David Rio Web, sin que puedan entenderse cedidos al usuario ninguno de los derechos de explotación sobre los mismos más allá de lo estrictamente necesario para el correcto uso del sitio web.
              </p>
              <p className="mt-4">
                Quedan expresamente prohibidas la reproducción, distribución y comunicación pública, incluida su modalidad de puesta a disposición, de la totalidad o parte de los contenidos de esta página web, con fines comerciales, en cualquier soporte y por cualquier medio técnico, sin la autorización de David Rio Web.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">5. Exclusión de garantías y responsabilidad</h2>
              <p>
                David Rio Web no se hace responsable, en ningún caso, de los daños y perjuicios de cualquier naturaleza que pudieran ocasionar, a título enunciativo:
              </p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Errores u omisiones en los contenidos</li>
                <li>Falta de disponibilidad del sitio web o la transmisión de virus o programas maliciosos</li>
                <li>Ausencia de veracidad, exactitud, exhaustividad y actualidad de los contenidos</li>
                <li>Uso inadecuado del sitio web</li>
                <li>Contenidos de sitios web de terceros a los que se pueda acceder mediante enlaces</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">6. Enlaces</h2>
              <p>
                El sitio web puede contener enlaces a otros sitios web de terceros. David Rio Web no asume ninguna responsabilidad por el contenido, políticas de privacidad o prácticas de sitios web de terceros. El usuario accede a estos sitios bajo su propia responsabilidad.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">7. Protección de datos</h2>
              <p>
                Para más información sobre el tratamiento de sus datos personales, consulte nuestra Política de Privacidad.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">8. Modificaciones</h2>
              <p>
                David Rio Web se reserva el derecho de efectuar sin previo aviso las modificaciones que considere oportunas en su sitio web, pudiendo cambiar, suprimir o añadir tanto los contenidos y servicios que se presten a través de la misma como la forma en la que estos aparezcan presentados o localizados.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">9. Legislación aplicable y jurisdicción</h2>
              <p>
                La relación entre David Rio Web y el usuario se regirá por la normativa española vigente. En caso de controversia, las partes podrán someter sus conflictos a arbitraje o acudir a la jurisdicción ordinaria, cumpliendo con las normas sobre jurisdicción y competencia al respecto.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">10. Contacto</h2>
              <p>
                Para cualquier consulta relacionada con este Aviso Legal, puede contactarnos a través del formulario de contacto disponible en nuestro sitio web.
              </p>
              <p className="mt-4">
                <strong>Última actualización:</strong> {new Date().toLocaleDateString('es-ES', { year: 'numeric', month: 'long', day: 'numeric' })}
              </p>
            </section>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}